<template>
  <div id="app" :class="siteClass">
    <router-view v-if="siteClass" />
  </div>
</template>

<script>
import config from './config/apiUrl';
import common from './config/common';
import {SHA256} from 'crypto-js';

export default {
  name: 'app',
  data() {
    return {
      siteClass: ''
    };
  },
  created() {
    this.setSiteId().then(siteClass => this.siteClass = siteClass);
  },
  methods: {
    setSiteId() {
      return new Promise((resolve) => {
        let siteId = localStorage.getItem('siteId'),
          displayText = localStorage.getItem('displayText'),
          url = location.href.split('/')[2];
//          url = 'galleria_gg.binzary.com';

        if (!siteId || !displayText) {
          const address = SHA256(url).toString();

          this.$http.get(config.siteIdUrl + address)
              .then(response => {
                if (response.data.siteId) {
                  ({ siteId, displayText } = response.data);
                  localStorage.setItem('siteId', siteId);
                  localStorage.setItem('displayText', displayText);
                  resolve(common[siteId].className);
                }
              });
        } else {
          resolve(common[siteId].className);
        }
      });
    },
  },
}
</script>

<style lang="scss">
  /* 공통 */
  body,p,h1,h2,h3,h4,h5,h6,ul,ol,li,dl,dt,dd,table,th,td,form,fieldset,legend,input,textarea,button,select{ margin:0; padding:0; color:#333; text-align: center; font-family: 'Noto Sans', sans-serif; border-style: none; }
  table{ border-collapse:collapse}
  img,fieldset{ border:0}
  ul,ol{ list-style:none}
  a{ color:inherit; text-decoration:none}

  html, body { height: 100%; margin: 0px;}
  /* 공통 끝*/

  @media (min-width:980px){
    html, body, {width:50%; margin:0 auto}
    .contents, div.top {width:50%;margin:0 auto}
  }

  p.info_txt {font-size: 22px; font-weight: 200}
  .h_middle {position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100%;}
  div.bg {background:#ddd; padding:60px 0 30px; min-height: 100%; widht:100%;}
  .map { overflow: scroll; padding: 60px 0 0px;}
  .toolbar { position: absolute; bottom: 30px; border: 0; left: 50%; color: #fff; font-weight: 700; -moz-transform: translateX(-50%); -o-transform: translateX(-50%); -webkit-transform: translateX(-50%); transform: translateX(-50%); padding: 0 5px; white-space: nowrap; background: #4b4e54; border-radius: 5px; height: 38px; line-height: 38px;}
  .toolbar > li { text-align: center; display: inline-block; padding: 0 10px; height: 100%; line-height: inherit; font-size: 25px; cursor: pointer; vertical-align: top; color:#fff;}
  .toolbar li.zoom {font-size:18px;}
  ul.car_num {margin: 10% auto 20%; text-align: center;}
  ul.car_num li {margin:1%; display:inline-block;}
  ul.car_num li input { height:2em; width:2em; border-radius: 5px; font-size:28px; border: 2px solid #fff; -webkit-appearance: none;}
  ul.car_num li input:focus {border:2px solid #fff; background:none; color:#fff;}

  div.top {padding:18px 0; background:#fff; box-shadow: 0px 6px 10px #999; font-size: 18px; position: fixed; width: 100%; top: 0; z-index:999;}
  input.back {background: url('./assets/back_icon.png') center center no-repeat; background-size: 50%; position:absolute; top:5px; left:0; width:50px; height:50px; z-index: 1000;}

  div.list {background:#fff; width:92%; margin:5% auto; font-size:16px; border-radius: 3%; box-shadow: 6px 6px 8px #999;}
  div.list p {text-align:left; padding:3px 20px;}
  div.list .mt5 {margin-top:5%;}
  div.list ul { border-top: 1px solid #ddd; border-bottom: 1px solid #ddd; margin-top: 5%}
  div.list ul li { display: inline-block; width:48%; border-left:1px solid #ddd; padding:5% 0 ;}
  div.list ul li:first-child {border-left:none;}

  .DARAE {
    div.g_bg {background: #15274a; font-size:16px;  min-height: 100%; position:absolute; width:100%; height:100%; }
    /*div.g_bg {background: #15274a;  padding:60px 0 60px; font-size:16px;  min-height: 100%;}*/
    h1 {text-align: center; padding:0 0 8%; color:#fff; font-weight: lighter;}
    h1 > img {width:70%; display: inline;}

    p.btn a {display: block; text-align: center; color:#15274a; background: #f3d420; width:60%; margin:0 auto; border-radius:30px; padding:12px 0; font-size:22px;}
    p.btn2 a {display: block; text-align: center; color:#15274a; background: #fae72a; border: 1px solid #fff; width:60%; margin:10% auto; border-radius:30px; padding:10px 0; font-size: 22px; font-weight: 200;}

    div.list ul li span{color:#105cb5; font-size:25px; font-weight:bold; padding-left: 2%;vertical-align: middle;}
    .click {background:#15274a; color:#fff; padding:10px 0; border-radius: 0 0 10px 10px;}
  }

  .SK {
    div.g_bg {background: linear-gradient( to bottom, #db0029, #f75e3a ); margin:0; padding:0; font-size:16px; position: absolute; width:100%; height:100%;}
    h1 {text-align: center; margin:20% 0 15%; color:#fff; font-weight: lighter;}
    h1 img {width:60%;}

    p.btn a {display: block; text-align: center; color:#fff; border: 1px solid #fff; width:60%; margin:0 auto; border-radius:30px; padding:10px 0; cursor: pointer;}
    p.btn2 a{display: block; text-align: center; color:#fff; background: linear-gradient( to right, #db0029, #f7503a ); border: 1px solid #fff; width:60%; margin:10% auto; border-radius:30px; padding:10px 0;}

    div.list ul li span{color:#ea002c; font-size:25px; font-weight:bold; padding-left: 2%;vertical-align: middle;}
    .click {background:#ea002c; color:#fff; padding:10px 0; border-radius: 0 0 10px 10px; cursor: pointer;}
  }

  .DONGSAN {
    div.g_bg {background: #003399; font-size:16px;  min-height: 100%; position:absolute; width:100%; height:100%; }
    h1 {text-align: center; margin:20% 0 15%; color:#fff; font-weight: lighter;}
    h1 img {width:80%; margin: 0 0 10px -15px;}
    h2 {text-align: center; margin-top: 20%;}
    h2 img {width: 30%;}

    p.btn a {display: block; text-align: center; color:#fff; border: 1px solid #fff; width:60%; margin:0 auto; border-radius:30px; padding:10px 0; cursor: pointer;}
    p.btn2 a {display: block; text-align: center; color:#fff; background: #003399; border: 1px solid #fff; width:60%; margin:10% auto; border-radius:30px; padding:10px 0; font-size: 22px; font-weight: 200;}

    div.list ul li span{color:#003399; font-size:25px; font-weight:bold; padding-left: 2%;vertical-align: middle;}
    .click {background:#003399; color:#fff; padding:10px 0; border-radius: 0 0 10px 10px; cursor: pointer;}
  }
</style>
